module.exports = __webpack_public_path__ + "static/media/minusScale.21e13fd2.svg";